import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";

const ReceiptSubtotal = ({
    total,
    subtotalLabel = "Subtotal",
    hasPromo,
    originalTotal,
}) => {
    return (
        <div className="grid -padding-bottom--10">
            <div className="col col--6">
                <p>
                    <strong>{subtotalLabel}</strong>
                </p>
            </div>
            <div className="col col--6 -text--right">
                <p>
                    {hasPromo && (
                        <span className="-text-decoration--line-through">
                            {originalTotal}
                        </span>
                    )}
                    <strong
                        className={cx(
                            hasPromo && "-color--system-error -padding-left--5",
                        )}
                    >
                        {total}
                    </strong>
                </p>
            </div>
        </div>
    );
};

ReceiptSubtotal.propTypes = {
    total: PropTypes.string.isRequired,
    subtotalLabel: PropTypes.string,
    hasPromo: PropTypes.bool,
    originalTotal: PropTypes.string,
};

export default ReceiptSubtotal;
